export default "__VITE_ASSET__YPxX$WWA__"